<template><section><template>
<h3>MultipleInput</h3>
<div class="bs-docs-section">
<div class="bs-example">
<n3-multiple-input @focus="focus" @inputChange="getResult" :async="true" v-model="a.list" :format="format" :item-render="itemRender" :items="items">
</n3-multiple-input>
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-multiple-input</span>
  <span class="hljs-attr">@focus</span>=<span class="hljs-string">"focus"</span> 
  <span class="hljs-attr">@inputChange</span>=<span class="hljs-string">"getResult"</span>
  <span class="hljs-attr">v-model</span>=<span class="hljs-string">"a.list"</span> 
  <span class="hljs-attr">:format</span>=<span class="hljs-string">"format"</span> 
  <span class="hljs-attr">:item-render</span>=<span class="hljs-string">"itemRender"</span>
  <span class="hljs-attr">:items</span>=<span class="hljs-string">"items"</span> &gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-multiple-input</span>&gt;</span>
</code></pre>
<pre v-pre=""><code v-pre="" class="language-javascript">methods: {
  focus () {
    <span class="hljs-built_in">console</span>.log(<span class="hljs-number">1</span>)
  },
  itemRender (item) {
    <span class="hljs-keyword">return</span> item.formatted_address
  },
  getResult (query) {
    <span class="hljs-built_in">console</span>.log(query, <span class="hljs-number">1</span>)
    <span class="hljs-keyword">let</span> self = <span class="hljs-keyword">this</span>
    $.ajax({
      <span class="hljs-attr">url</span>: <span class="hljs-string">'https://maps.googleapis.com/maps/api/geocode/json?address='</span> + query,
      success (ret) {
        self.items = ret.results
      }
    })
  },
  format (item, index) {
    <span class="hljs-keyword">let</span> content = item.formatted_address
    <span class="hljs-keyword">return</span> content
  }
}
</code></pre>
<h3>Params</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>data</td>
<td><code v-pre="">Array</code></td>
<td>-</td>
<td>locale data</td>
</tr>
<tr>
<td>format</td>
<td><code v-pre="">Function</code></td>
<td>-</td>
<td>format function</td>
</tr>
<tr>
<td>limit</td>
<td><code v-pre="">Number</code></td>
<td><code v-pre="">8</code></td>
<td>the limited number of items</td>
</tr>
<tr>
<td>items</td>
<td><code v-pre="">Array</code></td>
<td><code v-pre="">[]</code></td>
<td>suggestion items，for asyc</td>
</tr>
<tr>
<td>positionMove</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">true</code></td>
<td>whether the position of cursor can be moved or not</td>
</tr>
<tr>
<td>async</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>whether is async or not</td>
</tr>
<tr>
<td>item-render</td>
<td><code v-pre="">Function</code></td>
<td>-</td>
<td>itemRender function</td>
</tr>
<tr>
<td>add-format</td>
<td><code v-pre="">Function</code></td>
<td>-</td>
<td>format function to get right data</td>
</tr>
<tr>
<td>dropdown-width</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">220px</code></td>
<td>width of dropdown</td>
</tr>
<tr>
<td>dropdown-height</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">300px</code></td>
<td>max height of dropdown</td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>params</th>
</tr>
</thead>
<tbody>
<tr>
<td>blur</td>
<td>blur</td>
<td>-</td>
</tr>
<tr>
<td>focus</td>
<td>focus</td>
<td>-</td>
</tr>
<tr>
<td>change</td>
<td>change</td>
<td>(currentValue)</td>
</tr>
<tr>
<td>positionChange</td>
<td>the position of cursor change</td>
<td>(currentPosition)</td>
</tr>
<tr>
<td>inputChange</td>
<td>input value change</td>
<td>(query)</td>
</tr>
</tbody>
</table>
<p>PS: params of form components，look <a href="#n3FormDocs">Form</a> </p>
</div>
</template>

</section></template>

<script>
export default {
  data () {
    return {
      query: '',
      items: [],
      a: {list: []}
    }
  },
  methods: {
    focus () {
      console.log(1)
    },
    itemRender (item) {
      return item.formatted_address
    },
    getResult (query) {
      console.log(query, 1)
      let self = this
      $.ajax({
        url: 'https://maps.googleapis.com/maps/api/geocode/json?address=' + query,
        success (ret) {
          self.items = ret.results
        }
      })
    },
    format (item, index) {
      let content = typeof item === 'string' ? item : item.formatted_address
      return content
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3MultipleInputDocs.md?cbe2d418